import supabase from '../supabase/supabase';

export const notificationService = {
  notify: async (userId, title, message, action_link = null) => {
    if (!userId) return;
    try {
      await supabase.from('notifications_1740423033529').insert([{
        user_id: userId,
        title,
        message,
        action_link
      }]);
    } catch (err) {
      console.error("Notification Error:", err);
    }
  }
};